import { makeRequest } from 'utils/requestLogger';

export default (liveID) =>
  makeRequest('post', `/api/live_discussions/${liveID}/end`);



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/end.js